import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

import GetAppButton from './GetAppButton';
import { isAppStoreLanding } from '../../../api/helpers';
import { max } from '../../responsiveUtils';

const Buttons = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Cont>
        <GetAppButton isRuStore />
        <GetAppButton />
      </Cont>
      <Cont isBottom>
        <GetAppButton isApple  />
      </Cont>
      {!isAppStoreLanding ? (
        <>
          <Cont isBottom>
            <a href="#purchase">
              <GetAppButton isPayment isScrollButton />
            </a>
          </Cont>
          <Cont isBottom>
            <GetAppButton
              isPayment
              customText={t('purchaseGift')}
              customLink={'https://payment.cielomeditation.ru/certificate'}
            />
          </Cont>
          <Cont isBottom>
            <GetAppButton isPayment customText={t('login')} />
          </Cont>
        </>
      ) : null}
    </div>
  );
};

const Cont = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  ${(p) =>
    p.isBottom &&
    css`
      padding-top: 12px;
    `}
  a {
    text-decoration: none;
  }
  ${max('sm')`
    flex-direction: column;
    align-items: center;
    gap: 8px;
  `}
`;

export default Buttons;
